import { useRouteMatch } from "react-router-dom";

import { ComplianceProgramsList } from "@apps/programs/components/compliance-programs";
import useLabel from "@apps/use-label/use-label";
import Layout from "@components/layout/layout";

import AssessmentsHomepageActiveReviews from "./homepage-active-reviews";
import AssessmentHomepageDeliveries from "./homepage-deliveries";

enum AssessmentsHomepageTabs {
  Active = "Active",
  All = "All",
  PastReviews = "Past Reviews",
}

const AssessmentsHomepage = () => {
  const label = useLabel();
  const { path } = useRouteMatch();
  const selectedTab =
    path === "/assessments/delivered"
      ? AssessmentsHomepageTabs.PastReviews
      : path === "/assessments/all"
        ? AssessmentsHomepageTabs.All
        : AssessmentsHomepageTabs.Active;

  const reviewLabelPlural = label("review", {
    capitalize: true,
    pluralize: true,
  });

  const heading =
    selectedTab === AssessmentsHomepageTabs.PastReviews
      ? `Delivered ${reviewLabelPlural}`
      : selectedTab === AssessmentsHomepageTabs.All
        ? `All ${reviewLabelPlural}`
        : `Active ${reviewLabelPlural}`;

  return (
    <Layout.Main width="default">
      <div className="text-lg font-semibold text-gray-900">{heading}</div>
      {selectedTab === AssessmentsHomepageTabs.Active && (
        <AssessmentsHomepageActiveReviews />
      )}
      {selectedTab === AssessmentsHomepageTabs.All && (
        <div className="py-8">
          <ComplianceProgramsList />
        </div>
      )}
      {selectedTab === AssessmentsHomepageTabs.PastReviews && (
        <AssessmentHomepageDeliveries />
      )}
    </Layout.Main>
  );
};

export default AssessmentsHomepage;
